import React, { useContext, useCallback, useEffect, useMemo } from 'react';
import { useViewport } from '@fairygodboss/ui';
import { PageContext } from '../../../contexts/ContextCreator';
import { useJobSearchContext } from '../../../contexts/JobSearchContext';
import { JobsSearchResults } from './JobsSearchResults/JobsSearchResults';

export const JobsSearchResultsWrapper = () => {
    const {
        jobsSearch,
        content,
        totalJobs,
        setPage,
        page,
        setSingleJobUrl,
        onAlterToggleClick,
        jobAlert,
        jobNotifications,
        onJobSaveClick,
        singleJobUrl,
        isAuthenticatedUser,
        setIsMobileJobCardOpen,
        setSelectFirstJob,
        setJobNotifications,
        searchQueryId,
        searchIndexName,
        pageLimit,
        CTAJobSearch,
    } = useJobSearchContext();
    const {
        modalTrigger,
        fetchJobNotifications,
        jobNotifications: _jobNotifications,
    } = useContext(PageContext);
    const { isSM } = useViewport();

    useEffect(() => {
        setJobNotifications(_jobNotifications);
    }, [_jobNotifications, setJobNotifications]);

    const onJobClick = useCallback(
        (j) => {
            let companyUrl = j?.company?.url.split('/');
            companyUrl = companyUrl[companyUrl.length - 1];
            const slug = j?.hash;
            const url = `${companyUrl}/${slug}`;
            if (singleJobUrl !== url) {
                setSingleJobUrl(url);
            }
            // check if mobile
            if (!isSM) {
                setIsMobileJobCardOpen(true);
            }
        },
        [isSM, setIsMobileJobCardOpen, setSingleJobUrl, singleJobUrl]
    );

    const disableToggleAlert =
        jobsSearch?.keywords?.length && jobsSearch.location?.length;

    return useMemo(
        () => (
            <JobsSearchResults
                pageLimit={pageLimit}
                searchQueryId={searchQueryId}
                searchIndexName={searchIndexName}
                isAuthenticatedUser={isAuthenticatedUser}
                disableAlertToggle={!disableToggleAlert}
                onJobAlertSettingClick={() => {
                    fetchJobNotifications();
                    modalTrigger('FollowedJobs');
                }}
                alertToggleValue={!!jobAlert}
                onAlterToggleClick={onAlterToggleClick}
                totalJobs={totalJobs}
                totalJobAlerts={jobNotifications?.notificationCount || 0}
                jobSearchQuery={jobsSearch?.keywords || ''}
                jobSearchLocation={jobsSearch.location}
                activePage={page}
                onPageSelect={(pageNumber) => {
                    setSelectFirstJob(true);
                    setSingleJobUrl(null);
                    setPage(pageNumber);
                }}
                onSaveJob={onJobSaveClick}
                onJobSelect={onJobClick}
                jobsList={content}
                activeJob={singleJobUrl?.split('/')?.[1]}
            />
        ),
        [
            content,
            disableToggleAlert,
            fetchJobNotifications,
            isAuthenticatedUser,
            jobAlert,
            jobNotifications?.notificationCount,
            jobsSearch?.keywords,
            jobsSearch.location,
            modalTrigger,
            onAlterToggleClick,
            onJobClick,
            onJobSaveClick,
            page,
            setPage,
            setSelectFirstJob,
            setSingleJobUrl,
            singleJobUrl,
            totalJobs,
            searchIndexName,
            searchQueryId,
            CTAJobSearch,
        ]
    );
};
